angular.module('dpw.components')
    .directive('dpwSlider', ['$timeout', 'helpers', function ($timeout, helpers) {
        return {
            restrict: 'A',
            scope: {},
            transclude: true,
            templateUrl: 'dpw-slider.html',
            link: function (scope, element) {
                var viewWidth = element.find('.slider').width();
                scope.currentPageIndex = 0;
                scope.totalPages = 0;

                // $timeout to wait for `ng-repeat` to finish rendering
                $timeout(function () {
                    var $scroller = element.find('.slider-scroller');
                    var fullWidth = $scroller.width();

                    var $tiles = $scroller.children();
                    var contentWidth = 0;
                    angular.forEach($tiles, function (tile) {
                        contentWidth += $(tile).width();
                    });
                    // Calculate the space between two adjacent tiles
                    var spaceBetween = Math.ceil((fullWidth - contentWidth) / ($tiles.length - 1));
                    scope.totalPages = Math.ceil((fullWidth + spaceBetween) / (viewWidth + spaceBetween));

                    scope.switchToNextPage = function () {
                        if (scope.currentPageIndex < scope.totalPages - 1) {
                            scope.currentPageIndex++;
                            scrollToPage(scope.currentPageIndex);
                        }
                    };

                    scope.switchToPreviousPage = function () {
                        if (scope.currentPageIndex > 0) {
                            scope.currentPageIndex--;
                            scrollToPage(scope.currentPageIndex);
                        }
                    };

                    var $slider = element.find('.slider');
                    // Width +1px fixes the 1px bug on Safari/Mac.
                    $slider.width(viewWidth + 1);
                    function scrollToPage(pageNo) {
                        var scrollLeftPosition = (spaceBetween + viewWidth) * pageNo;
                        if (scrollLeftPosition < fullWidth) {
                            helpers.isIE9() ?
                                $scroller.css({
                                    left: '-' + scrollLeftPosition + 'px'
                                }) :
                                $scroller.css({
                                    'transform': "translate(-" + scrollLeftPosition + "px, 0px) translateZ(0px)"
                                });
                        }
                        // An ugly fix for IE10 not supporting the sliding transition smoothly.
                        // Quickly set and reset width value to force IE to re-render the view of `.slider`.
                        // Magic number 500 is the `transition-duration` defined in `_slider.sass` (+100ms for insurance).
                        $slider.width(viewWidth);
                        $timeout(function () {
                            $slider.width(viewWidth + 1);
                        }, 600);
                    }
                });
            }
        };
    }]);